import { Trans } from 'react-i18next';
import { ENoPeriodTableColumns } from './no-period-table.enum';
import { STableActiveCell } from './no-period-table.styles';
import { ColumnsType, TOperationsLimitsTableRecord, TOnCellClickHandler } from './no-period-table.types';

const columns = (
  onCellClickHandler: TOnCellClickHandler,
): ColumnsType<TOperationsLimitsTableRecord> => ([
  {
    title: <Trans i18nKey="limits.standardLimits.table.noPeriod.column.title.currency" />,
    dataIndex: ENoPeriodTableColumns.AsseCode,
    width: 205,
  },
  {
    title: <Trans i18nKey="limits.standardLimits.table.noPeriod.column.title.limit" />,
    key: ENoPeriodTableColumns.Limits,
    width: 1170,
    render: (value: string, record: TOperationsLimitsTableRecord) =>
      <STableActiveCell>
        {record?.min || <Trans i18nKey="limits.standardLimits.table.noPeriod.column.cell.placeholder.min" />}
        {` - `}
        {record?.max || <Trans i18nKey="limits.standardLimits.table.noPeriod.column.cell.placeholder.max" />}
      </STableActiveCell>,
    onCell: (record: TOperationsLimitsTableRecord) => ({
      onClick: (): void => {
        onCellClickHandler(record);
      },
    }),
  }
]);

export default columns;
